module.exports = __webpack_public_path__ + "media/images/manage_courses_inactive-4db2435f92c4f5dfe865eef5d9de9f22.png";